import { useEffect } from 'react';
import axios from 'axios';
import { GenerateOtpRequest, GenerateOtpResponse } from 'vopay';
import vopayApi from '../../services/api.config';

const hook = vopayApi.withApiHook(({ api }) => {
  return function useValidate() {
    const source = axios.CancelToken.source();

    const generateOtp = async (requestParams: GenerateOtpRequest): Promise<GenerateOtpResponse> => {
      try {
        const res = await api.postGenerateOtp(requestParams, source);

        if (res.Success) {
          return {
            Success: res.Success,
            ErrorMessage: '',
            Expiration: res.Expiration,
          };
        }
      } catch (error) {
        console.error(error);
      }

      return {
        Success: false,
        ErrorMessage: 'Failed to generate OTP',
        Expiration: '',
      };
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      generateOtp,
    };
  };
});

export default hook({});
